var _style, _path, _path2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMathBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D9DCE1;}\n\t.st1{fill:#56AAFF;}\n\t.st2{fill:none;stroke:#D9DCE1;stroke-width:2;stroke-linecap:square;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#D9DCE1;stroke-width:2;stroke-linecap:square;stroke-miterlimit:10;stroke-dasharray:0.1022,6.1323;}\n\t.st4{fill:#0478ED;}\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-linecap:square;stroke-miterlimit:10;}\n\t.st6{fill:#FFFFFF;}\n\t.st7{fill:none;stroke:#56AAFF;stroke-width:2;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\n\t.st9{fill:none;stroke:#0478ED;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:2,2;}\n\t.st10{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st11{fill:none;stroke:#56AAFF;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st12{fill:none;stroke:#FFFFFF;stroke-width:1.9806;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st13{fill:none;stroke:#D9DCE1;stroke-width:2;stroke-miterlimit:10;}\n\t.st14{fill:none;stroke:#D9DCE1;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st15{fill:none;stroke:#0478ED;stroke-width:2;stroke-miterlimit:10;}\n\t.st16{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st17{fill:none;stroke:#D9DCE1;stroke-width:4;stroke-miterlimit:10;}\n\t.st18{fill:none;stroke:#0478ED;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st19{fill:none;stroke:#56AAFF;stroke-width:3;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st20{fill:none;stroke:#0478ED;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st21{fill:none;stroke:#D9DCE1;stroke-width:11.1549;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st22{fill:none;stroke:#D9DCE1;stroke-width:3;stroke-miterlimit:10;}\n\t.st23{fill:none;stroke:#FFFFFF;stroke-width:2.2357;stroke-linecap:square;stroke-miterlimit:10;}\n\t.st24{fill:none;stroke:#0478ED;stroke-width:3;stroke-miterlimit:10;}\n\t.st25{fill:none;stroke:#D9DCE1;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st26{fill:none;stroke:#56AAFF;stroke-width:5;stroke-miterlimit:10;}\n\t.st27{fill:none;stroke:#0478ED;stroke-width:4;stroke-miterlimit:10;}\n\t.st28{fill:none;stroke:#D9DCE1;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st29{fill:none;stroke:#D9DCE1;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st30{fill:none;stroke:#56AAFF;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st31{fill:none;stroke:#FFFFFF;stroke-width:3;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st32{fill:none;stroke:#56AAFF;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st33{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-miterlimit:10;}\n\t.st34{fill:none;stroke:#56AAFF;stroke-width:3;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6,15v33h23c0,1.1,1.3,2,3,2s3-0.9,3-2h23V15H6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36,12c-1.6,0-2.9,0.9-3.6,2.2c-0.2,0.3-0.7,0.3-0.9,0c-0.7-1.3-2-2.2-3.6-2.2H9v33h19c1.6,0,2.9,0.9,3.6,2.2  c0.2,0.3,0.7,0.3,0.9,0c0.7-1.3,2-2.2,3.6-2.2h19V12H36z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 16,
    x2: 26,
    y1: 20,
    y2: 20
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 16,
    x2: 26,
    y1: 26,
    y2: 26
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 16,
    x2: 26,
    y1: 32,
    y2: 32
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 16,
    x2: 22,
    y1: 38,
    y2: 38
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 38,
    x2: 48,
    y1: 20,
    y2: 20
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 38,
    x2: 48,
    y1: 26,
    y2: 26
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 38,
    x2: 44,
    y1: 32,
    y2: 32
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "57,53.3 50.3,47.6 54.3,44.9 37,39.7 45.3,55.7 47.3,51.2 54,56.9 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMathBook);
export default __webpack_public_path__ + "static/media/math-book.030073600b2508d6a1a3224823a9d836.svg";
export { ForwardRef as ReactComponent };